export default {"src":"/login-app/[GIT_HASH]/_next/static/media/trending_down.73193d14.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};